<template>
<v-container fluid class="fullscreen">
  <v-row no-gutters>
    <v-col cols="12" md="12" class="pa-2">
      <v-card>
        <v-card-title>
          <v-row no-gutters>
            <v-col cols="12" md="2" class="px-2">
              <v-menu
                :close-on-content-click="false"
                transition="scale-transition"
                min-width="290px"
                v-model="fromMenu"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fromDateValue"
                    label="From Date"
                    prepend-icon="event"
                    hide-details
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker :max="new Date().toISOString().substr(0, 10)" :type="datePickerType" v-model="fromDate" @input="fromMenu = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="2" class="px-2">
              <v-menu
                :close-on-content-click="false"
                transition="scale-transition"
                min-width="290px"
                v-model="toMenu"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="toDateValue"
                    label="To Date"
                    prepend-icon="event"
                    hide-details
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker :max="new Date().toISOString().substr(0, 10)" :type="datePickerType" v-model="toDate" @input="toMenu = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="2" class="px-2">
              <v-select
                prepend-icon="apartment"
                item-value="cityId"
                item-text="cityName"
                :items="listCity"
                v-model="city"
                hide-details
                label="City"
              />
            </v-col>
            <v-col cols="12" md="3" class="px-2 pt-3">
              <v-select
                @change="changeBranch(branch)"
                item-text="branchName"
                item-value="branchId"
                prepend-icon="store"
                :items="listBranch"
                v-model="branch"
                label="Branch"
                hide-details
                dense
              />
            </v-col>
            <v-col cols="12" md="3" class="px-2 pt-3">
              <v-select
                @change="changeTownship(township)"
                item-value="townshipId"
                prepend-icon="business"
                item-text="townshipName"
                :items="listTownship"
                v-model="township"
                label="Township"
                hide-details
                dense
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-radio-group v-model="dateType" row hide-details>
                <v-radio label="Day" value="date"></v-radio>
                <v-radio label="Month" value="month"></v-radio>
                <v-radio label="Year" value="year"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="4" md="1">
              <v-checkbox label="From" v-model="chkFrom" dense hide-details />
            </v-col>
            <v-col cols="4" md="1">
              <v-checkbox label="To" v-model="chkTo" dense hide-details />
            </v-col>
            <v-col cols="4" md="7" class="pt-5 px-2 text-right">
              <v-btn color="primary" @click="search" fab small depressed>
                <v-icon>search</v-icon>
              </v-btn>
              <v-btn depressed fab small class="mx-1" color="primary" outlined>
                <v-icon>help</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-col>
    <v-col cols="12" md="12" class="px-2">
      <v-card>
        <v-card-title class="pa-0">
          <v-row no-gutters>
            <v-col cols="12" md="4" class="py-4 px-3">
              Complete Report
              <button icon type="button" v-on:click="onexport">
                <v-icon color="primary">assignment</v-icon>
              </button>
            </v-col>
            <v-col
              cols="12"
              md="4"
              offset-md="4"
              v-if="responseData.toTotal != 0 || responseData.fromTotal != 0"
            >
              <v-alert type="success" border="left" class="ma-2" dense>
                <b>
                  From Total
                  {{ responseData.fromTotal | defaultPaymentFormat }}
                </b>
                :
                <b>To Total {{ responseData.toTotal | defaultPaymentFormat }}</b>
              </v-alert>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-col>
    <v-col cols="12" md="12" class="pa-2">
      <v-row no-gutters>
        <v-col
          cols="12"
          v-if="responseData.reportList.length == 0"
          class="text-center"
        >No data available</v-col>
        <v-col
          v-for="(report, index) in responseData.reportList"
          :key="report.reportTitle + report.action + index"
          cols="12"
          md="3"
        >
          <v-card class="ma-1">
            <v-card-title class="primary white--text">
              <v-icon color="white" class="mr-2">event</v-icon>
              <h5>{{ report.reportTitle }} - {{ report.action | actionLabel }}</h5>
            </v-card-title>
            <v-card-text class="text--primary py-2">
              <v-row no-gutters>
                <v-col cols="6">Employee</v-col>
                <v-col cols="2" class="text-right">Times</v-col>
                <v-col cols="3" class="text-right">Price</v-col>
                <v-col cols="1"></v-col>
              </v-row>
              <v-row v-for="emp in report.employeeList" :key="emp.userId" no-gutters>
                <v-col cols="6">{{ emp.name }}</v-col>
                <v-col cols="2" class="text-right">{{ emp.times | defaultPaymentFormat }}</v-col>
                <v-col cols="3" class="text-right">{{ emp.price | defaultPaymentFormat }}</v-col>
                <v-col cols="1">
                  <v-btn text icon x-small @click="clickDetail(report, emp)">
                    <v-icon>chevron_right</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-divider />
              <v-row no-gutters>
                <v-col cols="6">Total</v-col>
                <v-col cols="2" class="text-right">
                  {{
                  report.totalTimes | defaultPaymentFormat
                  }}
                </v-col>
                <v-col cols="3" class="text-right">
                  {{
                  report.totalPrice | defaultPaymentFormat
                  }}
                </v-col>
                <v-col cols="1"></v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
    <v-dialog v-model="detailDialog" width="300">
      <v-card>
        <v-card-title class="striped-row">Detail Information</v-card-title>
        <v-card-text>
          <div class="text--primary">
            <h3 class="mt-3 mb-3">{{ dialogData.dialogTitle }}</h3>
            <v-divider />
            <v-row no-gutters class="pa-1 emp-title">
              <v-col cols="4">Times</v-col>
              <v-col cols="4">Price</v-col>
              <v-col cols="4">DeliPrice</v-col>
            </v-row>
            <v-row
              class="list-detail"
              v-for="data in dialogData.reportList"
              :key="data.times"
              no-gutters
            >
            <v-col cols="4" v-if="data.times==0">Total Deli</v-col>
              <v-col cols="4" v-else>{{ data.times | defaultPaymentFormat }}</v-col>
              <v-col cols="4">{{ data.price | defaultPaymentFormat }}</v-col>
              <v-col cols="4">{{ data.deliPrice | defaultPaymentFormat }}</v-col>
            </v-row>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
  </v-container>
</template>

<script>
import townshipService from "../service/TownshipService";
import reportService from "../service/ReportService";
import XLSX from "xlsx";
export default {
  beforeMount: function () {
    townshipService.getAllCity().then((data) => {
      let city = {
        cityId: 0,
        cityName: "All",
      };
      this.listCity.push(city, ...data);
    });
    this.loadTownshipAndBranch();
  },
  data: () => {
    return {
      toDate: new Date().toISOString().substr(0, 10),
      fromDate: new Date().toISOString().substr(0, 10),
      toMenu: false,
      fromMenu: false,
      dateType: "date",
      datePickerType: "date",
      listCity: [],
      listBranch: [],
      listTownship: [], //{"townshipId": 0,"cityDto": {"cityId": 0,"cityName": ""},"townshipName": ""}
      branch: 0,
      city: 0,
      township: 0,
      chkFrom: false,
      chkTo: true,
      responseData: {
        reportList: [],
        toTotal: 0,
        fromTotal: 0,
      },
      detailDialog: false,
      dialogData: {
        dialogTitle: "",
        reportList: [],
      },
    };
  },
  methods: {
    loadTownshipAndBranch: function () {
      townshipService.getBranchByCityId(this.city).then((data) => {
        this.listBranch = this.listBranch.filter((v) => false);
        let branch = {
          branchId: 0,
          branchName: "All",
        };
        this.listBranch.push(branch, ...data);
      });
      townshipService.getTownshipByCityId(this.city).then((data) => {
        this.listTownship = this.listTownship.filter((v) => false);
        let township = {
          townshipId: 0,
          townshipName: "ALL",
        };
        this.listTownship.push(township, ...data);
      });
    },
    changeTownship: function (townshipId) {
      if (townshipId != 0) {
        let selectedTownship = this.listTownship.find((v) => {
          return v.townshipId == townshipId;
        });
        this.city = selectedTownship.cityDto.cityId;
      }
    },
    changeBranch: function (branchId) {
      if (branchId != 0) {
        let selectedBranch = this.listBranch.find((v) => {
          return v.branchId == branchId;
        });
        this.city = selectedBranch.cityId;
      }
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      if (this.dateType == "date") {
        // const [year, month, day] = date.split("-");
        return `${day}-${month}-${year}`;
      } else if (this.dateType == "month") {
        // const [year, month, day] = date.split("-");
        return `${month}-${year}`;
      } else {
        // const [year, month, day] = date.split("-");
        return `${year}`;
      }
    },
    formatDateUrl(date) {
      //if (!date) return null;
      if (this.dateType == "month") {
        const [month, year] = date.split("-");
        return `01-${month}-${year}`;
      } else if (this.dateType == "year") {
        const [year] = date.split("-");
        return `01-01-${year}`;
      }
      return date;
    },
    search: function () {
      let request = [];
      let fDate = this.fromDateValue;
      let tDate = this.toDateValue;
      if (this.dateType == "month") {
        fDate = "01-" + fDate;
        tDate = "01-" + tDate;
      } else if (this.dateType == "year") {
        fDate = "01-01-" + fDate;
        tDate = "01-01-" + tDate;
      }
      if (this.chkFrom) {
        request.push(
          reportService.getCompletReport(
            fDate,
            tDate,
            "from",
            this.city,
            this.branch,
            this.township,
            this.dateType
          )
        );
      }
      if (this.chkTo) {
        request.push(
          reportService.getCompletReport(
            fDate,
            tDate,
            "to",
            this.city,
            this.branch,
            this.township,
            this.dateType
          )
        );
      }
      reportService.AXIOS.all(request).then(
        reportService.AXIOS.spread((fromData, toData) => {
          this.responseData.reportList = this.responseData.reportList.filter(
            (v) => false
          );
          this.responseData.toTotal = 0;
          this.responseData.fromTotal = 0;
          if (this.chkFrom && this.chkTo) {
          } else if (this.chkTo) {
            toData = JSON.parse(JSON.stringify(fromData));
            fromData = null;
          }

          if (fromData != undefined && fromData.reportList != undefined) {
            fromData.reportList.forEach((v) => {
              v.action = "from";
            });
            this.responseData.reportList.push(...fromData.reportList);
            this.responseData.fromTotal = fromData.total;
          }

          if (toData != undefined && toData.reportList != undefined) {
            toData.reportList.forEach((v) => {
              v.action = "to";
            });
            this.responseData.reportList.push(...toData.reportList);
            this.responseData.toTotal = toData.total;
          }

          let sortByDate = (o1, o2) => {
            if (o1.reportTitle < o2.reportTitle) {
              return -1;
            } else if (o1.reportTitle == o2.reportTitle) {
              if (o1.action == "to") {
                return -1;
              } else if (o1.action == "from") {
                return 1;
              }
              return 0;
            } else {
              return 1;
            }
          };
          this.responseData.reportList.sort(sortByDate);
        })
      );
    },
    clickDetail: function (report, emp) {
      reportService
        .getCompletDetailReport(
          report.reportTitle,
          report.action,
          this.city,
          this.branch,
          this.township,
          this.dateType,
          emp.userId
        )
        .then((data) => {
          this.detailDialog = true;
          let action = "";
          if (report.action == "to") {
            action = "Deliverer";
          } else if (report.action == "from") {
            action = "Collector";
          }
          this.dialogData.dialogTitle =
            report.reportTitle + " - " + emp.name + "(" + action + ")";
          this.dialogData.reportList = this.dialogData.reportList.filter(
            (v) => false
          );
          this.dialogData.reportList.push(...data);
        });
    },
    onexport() {
      var excelList = [];
      var header = {};
      header.date = "Date";
      header.status = "Status";
      header.deliverName = "Delivery Name";
      header.times = "Times";
      header.price = "Price";
      excelList.push(header);

      var reportList = this.responseData.reportList;
      for (var i = 0; i < reportList.length; i++) {
        var report = reportList[i];
        var date = report.reportTitle;
        var status = "";

        if (report.action == "to") {
          status = "Deliverer";
        } else if (report.action == "from") {
          status = "Collector";
        }

        var subReportList = report.employeeList;
        for (var j = 0; j < subReportList.length; j++) {
          var subReport = subReportList[j];
          var data = {};
          data.date = date;
          data.status = status;
          data.deliverName = subReport.name;
          data.times = subReport.times;
          data.price = subReport.price;
          excelList.push(data);
        }
        var data = {};
        data.date = date;
        data.status = "Total ";
        data.deliverName = "";
        data.times = report.totalTimes;
        data.price = report.totalPrice;
        excelList.push(data);
      }

      var data = {};
      data.date = "From Total ";
      data.status = this.responseData.fromTotal;
      excelList.push(data);
      var data = {};
      data.date = "To Total ";
      data.status = this.responseData.toTotal;
      excelList.push(data);

      var pokemonWS = XLSX.utils.json_to_sheet(excelList, {
        skipHeader: true,
      });

      pokemonWS["!cols"] = [
        { width: 13 },
        { width: 13 },
        { width: 20 },
        { width: 10 },
        { width: 10 },
      ];

      var workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, pokemonWS, "completeReport");
      XLSX.writeFile(workbook, "completeReport" + ".xlsx");
    },
  },
  filters: {
    actionLabel: function (action) {
      if (action == "to") {
        return "Deliverer";
      } else if (action == "from") {
        return "Collector";
      }
    },
  },
  computed: {
    toDateValue() {
      var toDatetemp = "";
      toDatetemp = this.formatDate(this.toDate);
      return toDatetemp;
    },
    fromDateValue() {
      var fromDatetemp = "";
      fromDatetemp = this.formatDate(this.fromDate);
      return fromDatetemp;
    },
  },
  watch: {
    city: function (value) {
      this.loadTownshipAndBranch();
    },
    dateType: function () {
      if (this.dateType != "year") {
        this.datePickerType = this.dateType;
      } else {
        this.datePickerType = "month";
      }
      //this.saleReportData.reportList = [];
      //this.saleReportData.total = 0;
    },
  },
};
</script>

<style scoped>
.striped-row {
  background: var(--v-primary-base);
  color: white;
  padding: 3px;
}
.emp .row div {
  padding: 2px;
}
.emp-title {
  font-weight: 400;
  font-size: 1.1em;
  background: gainsboro;
  margin-bottom: 2px;
}
.list-detail {
  font-weight: 300;
  padding: 1px;
  background: rgb(243, 243, 243);
  border-bottom: 1px solid rgb(233, 233, 233);
}
.list-detail .col {
  padding-left: 3px;
}
.fullscreen {
  height: 92vh;
}
</style>
